import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/free-fall-velocity-calculator',
  component: () => import('../../routes/FreeFallVelocityCalculator.svelte'),
  card: {
    id: 'free-fall-velocity-calculator',
    title: 'Free Fall Velocity Calculator',
    description:
      'Calculate the velocity, height, or time of any object in free fall using g × t, v = √(2 g h), and h = ½ g t². Supports Earth, Moon, Mars, Jupiter and 9 planet/body presets, metric/imperial units, mass-based kinetic energy, momentum, and weight force.',
    icon: 'vertical_align_bottom',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/free-fall-velocity-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Free Fall Velocity Calculator – v = √(2 g h) with Planet Presets',
    description:
      'Free free-fall velocity calculator: solve for v, h, or t using v = √(2 g h), v = g × t, h = ½ g t², t = √(2 h / g). Includes 9 planet/body presets (Earth, Moon, Mars, Jupiter, Sun), metric/imperial units, optional mass for kinetic energy and momentum. Air resistance is ignored.',
  },
};

export default meta;